module.exports = __webpack_public_path__ + "static/media/logo.c49ddb35.png";